export const ScimScope = {
    Employee: 'employee',
    Customer: 'customer',
    Contractor: 'contractor',
} as const;

export type ScimScope = typeof ScimScope[keyof typeof ScimScope];
